export const ItemVacio = (codTipoObjeto, idPadre) => {
  return {
    id: null,
    codTipoObjeto: codTipoObjeto,
    idObjeto: idPadre,
    tipoLink: null,
    anioPublicacion: null,
    mesPublicacion: null,
    diaPublicacion: null,
    fuenteInformacion: null,
    url: null,
    valido: null,
    fechaValidacion: null,
    observaciones: null,
  };
};

export const saveItem = (item) => {
  return {
    id: item.id,
    codTipoObjeto: item.codTipoObjeto
      ? item.codTipoObjeto
      : item.tipoObjeto && item.tipoObjeto.codigo,
    idObjeto: item.idObjeto,
    codTipoLink: item.tipoLink && item.tipoLink.codigo,
    anioPublicacion: item.anioPublicacion,
    mesPublicacion: item.mesPublicacion,
    diaPublicacion: item.diaPublicacion,
    idFuenteInformacion: item.fuenteInformacion && item.fuenteInformacion.id,
    url: item.url,
    valido: item.valido,
    fechaValidacion: item.fechaValidacion,
    observaciones: item.observaciones,
  };
};
